exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".colored-label {\n  padding-left: 5px;\n  padding-right: 5px;\n  border-radius: 5px;\n  font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/components/app-colored-label/app-colored-label.component.scss
// module id = ../../../../../angular/app/components/app-colored-label/app-colored-label.component.scss
// module chunks = main